import { Card } from '@populix/pop-ui'
import Link from 'next/link'
import { MdChecklist, MdLockOutline, MdRadar } from 'react-icons/md'

const SurveyRulesAndDisclaimer = () => {
  return (
    <Card>
      <div className='flex flex-col gap-2'>
        <h2 className='text-sm font-bold text-pop-business-blue'>Rules and Disclaimer</h2>
        <div className='col-span-2 flex flex-row items-center gap-3 rounded-lg border border-pop-gray-5 bg-pop-gray-6 px-3 py-2'>
          <MdRadar className='h-6 w-6 flex-shrink-0 text-pop-grey-600' />
          <h2 className='text-xs font-normal'>
            We&apos;ll carefully review your survey submission, considering various factors.
          </h2>
        </div>
        <div className='col-span-2 flex flex-row items-center gap-3 rounded-lg border border-pop-gray-5 bg-pop-gray-6 px-3 py-2'>
          <MdChecklist className='h-6 w-6 flex-shrink-0 text-pop-grey-600' />
          <h2 className='text-xs font-normal'>
            Please ensure that your responses are genuine and truthful. Inconsistencies or
            misleading information may lead to rejection.
          </h2>
        </div>
        <div className='col-span-2 flex flex-row items-center gap-3 rounded-lg border border-pop-gray-5 bg-pop-gray-6 px-3 py-2'>
          <MdLockOutline className='h-6 w-6 flex-shrink-0 text-pop-grey-600' />
          <h2 className='text-xs font-normal'>
            Some surveys may link to external sites. Please ensure you understand their privacy
            policies before sharing any personal information.
          </h2>
        </div>
        <p className='text-xs font-normal text-pop-neutral-gray'>
          For additional details, please review the{' '}
          <Link
            href='/articles/terms-and-condition'
            className='cursor-pointer text-pop-dodger-blue underline'
          >
            Terms and Conditions
          </Link>{' '}
          and{' '}
          <Link
            href='/articles/privacy-policy'
            className='cursor-pointer text-pop-dodger-blue underline'
          >
            Privacy Policy
          </Link>{' '}
          here.
        </p>
      </div>
    </Card>
  )
}

export default SurveyRulesAndDisclaimer
